/* eslint-disable react/forbid-prop-types */
/*
 * @category  Puma
 * @author    Deniss Dubinins <denissd@scandiweb.com | info@scandiweb.com>
 * @license   http://opensource.org/licenses/OSL-3.0 The Open Software License 3.0 (OSL-3.0)
 * @copyright Copyright (c) 2021 Scandiweb, Inc (https://scandiweb.com)
 */

import PropTypes from 'prop-types';

import SourceTextPlaceholder from 'SourceComponent/TextPlaceholder/TextPlaceholder.component';

/** @namespace Scandipwa/Component/TextPlaceholder/Component */
export class TextPlaceholderComponent extends SourceTextPlaceholder {
    static propTypes = {
        ...super.propTypes,
        content: PropTypes.any
    };
}

export default TextPlaceholderComponent;
